import { DocumentTypeApi, documentTypesApi } from "api/documentTypesApi";
import { useEffect, useState } from "react";

export const useDocumentType = (documentTypeId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<DocumentTypeApi | null>(null);

  const fetchResource = async () => {
    if (!documentTypeId) {
      console.error("Document type id not found.");
      setLoading(false);
      return;
    }
    const res = await documentTypesApi.fetchById(documentTypeId);
    try {
      setData(res.data);
    } catch (error) {
      // Handle error appropriately, perhaps with another state variable
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchResource();
  }, [documentTypeId]);

  return { loading, data, refresh: () => fetchResource() };
};
